const MobileRouter = [
  {
    path: '/tpm/task',
    component: () => import('@/views/test/tpm/index'),
    hidden: true,
    name: 'tpmTaskList',
    meta: { title: 'tpm工单' }
  },
  {
    path: '/tpm/taskDetail/:id',
    component: () => import('@/views/test/tpm/detail'),
    hidden: true,
    props: true,
    name: 'tpmTaskDetail',
    meta: { title: 'tpm工单详情' }
  }
]

export default MobileRouter
